import { render } from "./NewEntity.vue?vue&type=template&id=242f7760&ts=true"
import script from "./NewEntity.vue?vue&type=script&lang=ts"
export * from "./NewEntity.vue?vue&type=script&lang=ts"

import "./NewEntity.vue?vue&type=style&index=0&id=242f7760&lang=css"
import "./NewEntity.vue?vue&type=style&index=1&id=242f7760&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__